export default __webpack_public_path__ + "static/media/st-button.21266a61.svg";